import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import speaking from '../data/speaking/speaking';
import essays from '../data/writing/Essays/essays';
import complaints from '../data/writing/complaints/complaints';
import letters from '../data/writing/letters/letters';
import opinions from '../data/writing/opinions/opinions';
import './styles/WritingScreen.css';

const WritingScreen = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const items = [
    { label: t('complaints'),      icon: 'warning',  color: 'var(--color-error)',    bgColor: 'var(--color-error-dim)',    data: complaints },
    { label: t('opinions'),        icon: 'mic',      color: 'var(--color-writing)',  bgColor: 'var(--color-writing-dim)', data: opinions },
    { label: t('letters'),         icon: 'mail',     color: 'var(--color-success)',  bgColor: 'var(--color-success-dim)', data: letters },
    { label: t('essays'),          icon: 'pen',      color: 'var(--color-vocab)',    bgColor: 'var(--color-vocab-dim)',   data: essays },
    { label: t('speakingContent'), icon: 'headphones', color: 'var(--color-progress)', bgColor: 'var(--color-progress-dim)', data: speaking },
  ];

  return (
    <div className="container">
      <BackButton to="/" label={t('home')} />
      <h2 className="page-title">{t('writing')}</h2>
      <div className="section-cards">
        {items.map((item, index) => (
          <button className="section-card" key={index} onClick={() => navigate('/choose-writing', { state: { content: item.data } })}>
            <div className="section-icon-container" style={{ backgroundColor: item.bgColor }}>
              <span className="section-icon" style={{ color: item.color }}><Icon name={item.icon} size={24} /></span>
            </div>
            <div className="section-card-text">
              <span className="section-card-title" style={{ color: item.color }}>{item.label}</span>
            </div>
            <span className="section-card-arrow">&rsaquo;</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default WritingScreen;
